// eslint-disable-next-line import/prefer-default-export
export const userRole = { AGENT_NAVIGATOR: 'AGENT', MEMBER: 'MEMBER' };
